import { useDispatch } from "react-redux";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";

import { TiVoPublications } from "./types";

export const useUpdatePublications = (platformId?: string) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation<void, Error, Pick<TiVoPublications, "id" | "platforms">[]>(
    {
      mutationFn: async (data) => {
        return dispatch(
          apiThatThrows.updateTiVoPublications.action({
            params: { platformId },
            options: {
              body: JSON.stringify({
                data: data.map(({ id, platforms }) => ({
                  attributes: { publications: platforms[0].publications },
                  id,
                  type: "string",
                })),
              }),
            },
          })
        );
      },
      onSuccess() {
        queryClient.invalidateQueries({ queryKey: ["publications"] });
      },
    }
  );
};
